'use client'

import {useEffect} from 'react'
import {useTranslations} from 'next-intl'
import {Button, Card} from '@/design-system'

/**
 * Route-group error boundary (T-WEB-08).
 *
 * Shows a localized message and a retry, never the thrown error: an API
 * failure message is developer text, and on a page that renders someone's
 * profile it could carry data they would not expect to see on screen.
 */
export default function AppError({
  error,
  reset
}: {
  error: Error & {digest?: string}
  reset: () => void
}) {
  const t = useTranslations('common')

  useEffect(() => {
    // Sentry's Next.js integration picks this up; the digest is what ties a
    // user report to a server log line.
    console.error(error)
  }, [error])

  return (
    <Card size="lg" role="alert">
      <h1 style={{marginTop: 0}}>{t('somethingWentWrong')}</h1>
      <p style={{color: 'var(--text-muted)'}}>{t('tryAgainLater')}</p>
      <Button onClick={reset}>{t('retry')}</Button>
    </Card>
  )
}
